import {
  faBoxOpen,
  faHome,
  faRightFromBracket,
  type IconDefinition,
} from '@fortawesome/free-solid-svg-icons';
import { ref } from 'vue';
import { createRouter, createWebHistory } from 'vue-router';
import DefaultLayout from '../layout/DefaultLayout.vue';
import { registerLoading } from '../stores/loadingStore';

declare module 'vue-router' {
  interface RouteMeta {
    /** Navbar/sidebar icon */
    icon?: IconDefinition;
    /** Hide the route from generated navigation */
    hide?: boolean;
    /** Container width class for the main slot */
    width?: string;
    fullHeight?: boolean;
    verticalScroll?: boolean;
    horizontalScroll?: boolean;
    section?: 'top' | 'bottom';
    /** Reachable without authentication */
    public?: boolean;
  }
}

const routeLoading = ref(false);

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      component: DefaultLayout,
      children: [
        {
          name: 'home',
          path: '',
          meta: { icon: faHome, section: 'top' },
          components: {
            default: () => import('../views/HomeView.vue'),
            navbar: () => import('../views/navbar/DefaultNavbar.vue'),
          },
        },
        {
          name: 'orders',
          path: 'orders',
          meta: { icon: faBoxOpen, section: 'top' },
          components: {
            default: () => import('../views/OrdersView.vue'),
            navbar: () => import('../views/navbar/DefaultNavbar.vue'),
          },
        },
        {
          name: 'notFound',
          path: '/:pathMatch(.*)*',
          meta: { hide: true, public: true },
          components: {
            default: () => import('../views/NotFoundView.vue'),
            navbar: () => import('../views/navbar/DefaultNavbar.vue'),
          },
        },
      ],
    },
    {
      name: 'logout',
      path: '/logout',
      meta: { icon: faRightFromBracket, hide: true },
      component: () => import('../views/LogoutView.vue'),
    },
  ],
});

// Global route-transition loading state, consumed by the layout.
// Registered lazily (not at module scope) since this file is imported before
// `app.use(pinia)` runs in main.ts, and useLoadingStore() requires an active Pinia.
let loadingRegistered = false;

router.beforeEach(() => {
  if (!loadingRegistered) {
    loadingRegistered = true;
    registerLoading(routeLoading);
  }
  routeLoading.value = true;
});

router.afterEach(() => {
  routeLoading.value = false;
});

export default router;
